import { render, staticRenderFns } from "./ManageConsentGA.vue?vue&type=template&id=519b13f8&scoped=true"
import script from "./ManageConsentGA.vue?vue&type=script&lang=ts"
export * from "./ManageConsentGA.vue?vue&type=script&lang=ts"
import style0 from "./ManageConsentGA.vue?vue&type=style&index=0&id=519b13f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519b13f8",
  null
  
)

export default component.exports